<template>
  <div v-show="active === ruleForm.status">
    <el-dialog title="Bling" :visible.sync="dialog" :width="'70%'">
      <el-form :model="ruleForm">
        <el-form-item label="Nome">
          <el-input v-model="ruleForm.configuration['txt-name']" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Client Id">
          <el-input v-model="ruleForm.configuration['clientId']" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Client Secret">
          <el-input v-model="ruleForm.configuration['clientSecret']" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Status do pedido para integrar">
          <el-input v-model="ruleForm.configuration['slc-status']" autocomplete="off"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="Código SEDEX">
              <el-input v-model="ruleForm.configuration['txt-sedex']" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Código PAC">
              <el-input v-model="ruleForm.configuration['txt-pac']" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="padding-top: 10px;">
          <el-col>
            <el-checkbox v-model="ruleForm.configuration['nf-valor-declarado']"
              :checked="ruleForm.configuration['nf-valor-declarado'] == 'S' ? true : false">
              Usar valor da NF como valor declarado
            </el-checkbox>
          </el-col>
          <el-col>
            <el-checkbox v-model="ruleForm.configuration['loja-departamento']"
              :checked="ruleForm.configuration['loja-departamento'] == 'S' ? true : false">
              Usar Número da Loja como Departamento
            </el-checkbox>
          </el-col>
          <el-col>
            <el-checkbox v-model="ruleForm.configuration['sobrescrever-rastreio']"
              :checked="ruleForm.configuration['sobrescrever-rastreio'] == 'S' ? true : false">
              Substituir rastreio existente do pedido pelo da +Envios
            </el-checkbox>
          </el-col>
        </el-row>
        <el-row style="padding-top: 10px;">
          <el-col>
            <span style="font-weight: bold; font-size: 14px; color: rgb(149, 145, 145);">Callback de pedidos de
              venda:</span>
          </el-col>
          <el-col>
            <span style="font-weight: bold; font-size: 12px; color: rgb(149, 145, 145);">
              https://integracao.sistemamaisenvios.com.br/portalmaisenvios/integracoes/webhook/bling/{{ customer }}
            </span>
          </el-col>
        </el-row>

        <!-- Servicos disponíveis -->
        <el-row style="padding-top: 15px;">
          <el-col>
            <span style="font-weight: bold;">Serviços Disponíveis</span>
          </el-col>
          <div class="table-services">
            <div style="display: flex;">
              <div class="services-table-header">
                <span>Código</span>
                <span>Nome original do Serviço</span>
              </div>
              <div class="services-table-header">
                <span>Nome utilizado na Integradora</span>
              </div>
            </div>

            <el-row class="services-body" v-for="item of customerServices" :key="item.serviceCode">
              <el-checkbox @change="selectService(item)" style="margin-right: 3px;"></el-checkbox>
              <el-input class="service-code" disabled v-model="item.serviceCode"></el-input>
              <el-input class="service-name" disabled v-model="item.serviceOriginalName"></el-input>
              <el-input class="service-new-name" v-model="item.newName"></el-input>
            </el-row>
          </div>
        </el-row>
        <!-- Serviços utilizados -->
        <el-row style="padding-top: 15px;">
          <el-col>
            <span style="font-weight: bold;">Serviços Configurados</span>
          </el-col>
          <div class="table-services">
            <div style="display: flex;">
              <div class="_services-config-header">
                <span>Código</span>
                <span>Nome utilizado na Integradora</span>
              </div>
            </div>

            <div class="services_container">
              <div>
                <el-row v-if="ruleForm.configuration" class="services-body"
                  v-for="item of ruleForm.configuration['service-code']" :key="item">
                  <el-checkbox @change="filterServices(item)" :checked="true" style="margin-right: 3px;"></el-checkbox>
                  <el-input class="service-code" disabled :value="item"></el-input>
                </el-row>
              </div>
              <div>
                <el-row v-if="ruleForm.configuration" class="services-body"
                  v-for="item of ruleForm.configuration['service-new-name']" :key="item">
                  <el-input class="service-code" disabled :value="item"></el-input>
                </el-row>
              </div>
            </div>
          </div>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" v-if="ruleForm.id" @click="remove()">Desativar integração</el-button>
        <el-button @click="dialog = false">Voltar</el-button>
        <el-button type="success" @click="save()">Salvar</el-button>
      </span>
    </el-dialog>
    <IntegrationCard image="/img/integration/logo-bling.svg" title="Bling"
      :status="ruleForm.status" :updatedAt="ruleForm.updatedAt" :options="ruleForm.options" :id="ruleForm.id"
      @configure="dialog = true" />
  </div>
</template>
<script>
import { i18n } from "@/plugin/i18n";
import { IntegrationService } from "@/services/customers/integration.services";
import IntegrationCard from "../components/IntegrationCard.vue";
import { CustomerService } from "@/services/customers/customers.services";

export default {
  name: "Integration",
  props: ["customer", "active"],
  methods: {
    setConfig(config) {
      const vm = this;
      vm.ruleForm.configuration = config.configuration
      vm.ruleForm.id = config.id;
      vm.ruleForm.status = config.status;
      vm.ruleForm.updatedAt = config.updatedAt;
      if (vm.customer) this.getCustomerData(vm.customer)
    },

    selectService(value) {
      this.servicesSelected.push(value)
    },

    filterServices(value) {
      console.log('value', value)
      const vm = this;

      const itemIndex = vm.ruleForm.configuration['service-code'].findIndex(i => i == value)

      if (itemIndex !== -1) {
        vm.ruleForm.configuration['service-code'].splice(itemIndex, 1);
        vm.ruleForm.configuration['service-new-name'].splice(itemIndex, 1)
      }
    },

    getCustomerData(customerId) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      CustomerService.get(customerId).then(response => {
        const servicesData = response.service ? response.service.map((item) => ({
          serviceCode: item.code,
          serviceOriginalName: item.name,
          newName: ""
        })) : []
        const config = vm.ruleForm.configuration

        const filteredServiceData = config['service-code']
          ? servicesData.filter(item => !config['service-code']
            .includes(item.serviceCode))
          : servicesData

        vm.customerServices = filteredServiceData
      })
        .catch(error => console.log(error))
        .finally(() => loading.close());
    },

    reset() {
      const vm = this;
      vm.ruleForm = {
        id: "",
        status: false,
        options: [],
        configuration: {
          clientId: '',
          clientSecret: '',
          "txt-chave": "",
          "txt-name": "",
          "txt-pac": "",
          "txt-sedex": "",
          "slc-status": "",
          "nf-valor-declarado": "",
          "loja-departamento": "",
          "sobrescrever-rastreio": "",
          "service-code": [],
          "service-new-name": []
        },
        updatedAt: "Sem registros",
      };
    },

    save() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      const { configuration } = vm.ruleForm

      configuration['loja-departamento'] = configuration['loja-departamento'] ? 'S' : '';
      configuration['nf-valor-declarado'] = configuration['nf-valor-declarado'] ? 'S' : '';
      configuration['sobrescrever-rastreio'] = configuration['sobrescrever-rastreio'] ? 'S' : '';

      if (!configuration['service-code']) configuration['service-code'] = []
      if (!configuration['service-new-name']) configuration['service-new-name'] = []

      if (vm.servicesSelected.length > 0) {
        for (const service of vm.servicesSelected) {
          configuration['service-code'].push(service.serviceCode)
          configuration['service-new-name'].push(service.newName || "")
        }
      }

      configuration['service-code'] = [...new Set(configuration['service-code'])]
      configuration['service-new-name'] = [...new Set(configuration['service-new-name'])]

      if (vm.ruleForm.id) {
        console.log('config', configuration)
        //IntegrationService.update(vm.ruleForm.id, {
        IntegrationService.auth2({
          type: "2",
          configuration: configuration,
          customer: vm.customer,
          id: vm.ruleForm.id,
        })
          .then((response) => {
            if (response.redirect) {
              window.open(response.redirect,'_blank', 'popup=true, width=400, height=500');
            } else {
              setTimeout(() => {
                vm.$emit("refresh");
              }, 300);
              this.$message({
                type: "success",
                message: i18n.tc("integracao-adicionado-sucesso"),
              });
            }
            vm.dialog = false;
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
      }
      else {
        IntegrationService.auth2({
          type: "2",
          configuration: configuration,
          customer: vm.customer
        })
          .then((response) => {
            if (response.redirect) {
              window.open(response.redirect,'_blank', 'popup=true, width=400, height=500');
            } else {
              setTimeout(() => {
                vm.$emit("refresh");
              }, 300);
              this.$message({
                type: "success",
                message: i18n.tc("integracao-adicionado-sucesso"),
              });
            }
            vm.dialog = false;
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
      }
    },
    remove: function (id, name) {
      const vm = this;
      this.$confirm(i18n.t("confirmar-eliminacao-integracao", { id: "Bling" }),
        i18n.tc("aviso"), {
        confirmButtonText: "OK",
        cancelButtonText: i18n.tc("cancelar"),
        type: i18n.tc("aviso"),
        center: true,
      }).then(() => {
        const loading = vm.$loading(vm.$options.loading);
        IntegrationService.unregister({ customer: vm.customer, type: "2" })
          .then((response) => {
            setTimeout(() => {
              vm.$emit("refresh");
              vm.dialog = false;
            }, 300);
            this.$message({
              type: "success",
              message: i18n.tc("integracao-eliminado-sucesso"),
            });
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
      });
    },
  },
  data() {
    return {
      ruleForm: {
        id: "",
        status: false,
        options: [],
        configuration: {
          "txt-chave": "",
          "txt-name": "",
          "txt-pac": "",
          "txt-sedex": "",
          "slc-status": "",
          "txt-callback": "",
          "nf-valor-declarado": "",
          "loja-departamento": "",
          "sobrescrever-rastreio": "",
          "service-code": [],
          "service-new-name": []
        },
        updatedAt: "Sem registros",
      },
      dialog: false,
      customerServices: undefined,
      servicesSelected: []
    };
  },
  components: { IntegrationCard }
};
</script>
<style>
.table-services {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.services-table-header {
  display: flex;
  width: 50%;
  padding: 5px;
  justify-content: space-around;
  align-items: center;
}

.services_container {
  display: flex;
}

._services-config-header {
  display: flex;
  width: 50%;
  padding: 5px;
  justify-content: space-between;
  align-items: center;
}

._services-config-header span {
  font-weight: bold;
  color: #999
}

._services-config-header span:first-child {
  margin-left: 30px;
}

.services-table-header span:last-child {
  padding-right: 35px;
}

.services-table-header span {
  font-weight: bold;
  color: #999
}

.services-body {
  display: flex;
  align-items: center;
}

.services-body input {
  margin: 3px;
}

.service-code {
  width: 250px;
  margin-right: 5px;
}

.service-name {
  width: 500px;
  margin-right: 5px;
}

.right {
  float: right;
}

.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.integration-image {
  margin: 5px;
  height: 40px;
}

.w-33 {
  width: 33%;
}

.w-50 {
  width: 50%;
}
</style>